module.exports = window.CustomEvent || {};
